Namespace 'Profile.UserProfile'
class Profile.UserProfile.MergeCandidateCount extends Backbone.Model
  initialize: ({ source, social_network_id }) ->
    _social_network_id = encodeURIComponent(social_network_id)
    @source = source
    @social_network_id = social_network_id
    @url = "/profiles/api/#{@source}/#{_social_network_id}/candidates/count"

  candidatesCount: ->
    @get('count')
